

export default function RestHeader(){


    return(
        <div className="container w-[80%] mx-auto py-4 px-8 mt-5 bg-gray-200 text-5xl flex justify-between items-center">
            <div>
                <p className="text-orange-600 font-bold">Swiggy</p>
            </div>
            <div className="font-semibold text-xl">
                <p>Swiggy Corporate</p>
            </div>
            <div className="font-semibold text-xl">
                <p>Search</p>
            </div>
             <div className="font-semibold text-xl">
                <p>Offers</p>
            </div>
            <div className="font-semibold text-xl">
                <p>Help</p>
            </div>
            <div className="font-semibold text-xl">
                <p>Sign In</p>
            </div>
            <div className="font-semibold text-xl">
                <p>Cart</p>
            </div>
        </div>
    )
}